import { Stack, Typography } from '@mui/material';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutline from '@mui/icons-material/ErrorOutlined';
import type { KpiId } from '@serb/shared';
import { kpiMet, kpiTargetText } from '../lib/kpi';

/** Next to an actual number: the acceptable rate from Settings, and whether the number meets it (icon and words, not colour alone) */
export function KpiTarget({ id, actual }: { id: KpiId; actual: number | null }) {
  const met = actual === null ? null : kpiMet(id, actual);
  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', justifyContent: 'center' }}>
      {met === true && <CheckCircleOutline sx={{ fontSize: 16 }} color="success" />}
      {met === false && <ErrorOutline sx={{ fontSize: 16 }} color="error" />}
      <Typography
        variant="caption"
        color={met === false ? 'error.main' : 'text.secondary'}
        sx={{ fontWeight: met === false ? 700 : 400 }}
      >
        Acceptable {kpiTargetText(id)}
        {met === null ? '' : met ? ': met' : ': below target'}
      </Typography>
    </Stack>
  );
}
